let lastScrollPosition = 0;
window.addEventListener('scroll', function() {
    let body = document.body;
    let scrollPosition = window.scrollY || document.documentElement.scrollTop;
    if (scrollPosition > 200) {
        body.classList.add('scrolled');
        if (scrollPosition > 500) {
            body.classList.add('scrolled-down');
        }
        else{
            body.classList.remove('scrolled-down');
        }
    } else {
        body.classList.remove('scrolled', 'scrolled-up', 'scrolled-down');
    }
    lastScrollPosition = scrollPosition;
});
//# sourceMappingURL=scroll-menu-dark.js.map
